import { builtInViews } from "@hq/core";
import { cn } from "@z/ui";
import { Sunrise } from "lucide-react";
import { QuickAdd } from "../QuickAdd";
import { TaskList } from "../TaskList";
import { ViewHeader } from "../ViewHeader";
import { type ViewProps, viewClassName } from "./shared";
import { useViewState } from "./useViewState";

/** The holding pen. Tasks here never appear in Today or Upcoming until reactivated. */
export function SomedayView({ onOpenTask, now, className }: ViewProps) {
  const s = useViewState(builtInViews.someday);
  return (
    <div data-slot="someday-view" className={cn(viewClassName, className)}>
      <ViewHeader
        mode={s.mode}
        onModeChange={s.setMode}
        title={
          <span className="inline-flex items-center gap-2">
            <Sunrise className="size-4 text-fg-muted" />
            Someday
          </span>
        }
        sort={s.sort}
        onSortChange={s.setSort}
        tags={s.tags}
        onTagsChange={s.setTags}
        availableTags={s.hasTasks ? s.allTags : []}
        displayControls={s.hasTasks && s.mode === "list"}
        groupBy={s.groupBy}
        onGroupByChange={s.setGroupBy}
      />
      <TaskList
        view={s.view}
        mode={s.mode}
        onTagClick={s.toggleTag}
        quickAdd={
          <QuickAdd
            {...(now ? { now } : {})}
            placeholder="Add an idea for someday… (“someday” is added for you)"
          />
        }
        emptyTitle="Nothing parked"
        emptyDescription="Move a task here from its menu, or type “someday” in the quick add."
        {...(onOpenTask ? { onOpenTask } : {})}
        {...(now ? { now } : {})}
      />
    </div>
  );
}
